<template>
    <div class="py-12 bg-white">
        <div class="flex flex-col justify-center items-center space-y-4">
            <div class="text-center">
                <div class="font-medium text-gray-700">
                    {{ title }}
                </div>
                <div
                    v-if="subtitle"
                    class="text-sm text-gray-600"
                >
                    {{ subtitle }}
                </div>
            </div>
            <div v-if="slots.action">
                <slot name="action" />
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { useSlots } from 'vue'

    const slots: any = useSlots()

    const props = defineProps({
        title: {
            type: String,
            required: true,
        },
        subtitle: {
            type: String,
            default: null,
        },
    })
</script>
